const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icon_feather-mail",
  "data-name": "Icon feather-mail",
  transform: "translate(1.393 1)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_2677",
  "data-name": "Path 2677",
  d: "M5.022,6H21.2a2.028,2.028,0,0,1,2.022,2.022V20.157A2.028,2.028,0,0,1,21.2,22.179H5.022A2.028,2.028,0,0,1,3,20.157V8.022A2.028,2.028,0,0,1,5.022,6Z",
  transform: "translate(-3 -6)",
  fill: "none",
  stroke: "#707070",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2678",
  "data-name": "Path 2678",
  d: "M23.224,9,13.112,16.078,3,9",
  transform: "translate(-3 -6.978)",
  fill: "none",
  stroke: "#707070",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}));
function SvgIconfeatherMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.009,
    height: 18.179,
    viewBox: "0 0 23.009 18.179",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconfeatherMail);
export default __webpack_public_path__ + "static/media/Icon feather-mail.cf09eab2.svg";
export { ForwardRef as ReactComponent };